










import { computed, defineComponent, PropType } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { BaseMenuItem } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseMenu from "@/components/BaseMenu";
import { FilterName } from "../../types";

// "All files" / "Unused": the same filter when files are picked for a post or a message and in the Vault itself
export default defineComponent({
  name: "VaultFilterMenu",
  components: { BaseIcon, BaseMenu },
  props: {
    value: { type: String as PropType<FilterName>, default: FilterName.ALL },
  },
  setup(props, { emit }) {
    const filterItems: BaseMenuItem[] = [
      { name: FilterName.ALL, text: $t("All files") },
      { name: FilterName.UNUSED, text: $t("Unused") },
    ];
    const activeItem = computed(() => filterItems.find(i => i.name === props.value) ?? filterItems[0]);
    const onClick = (name: FilterName) => emit("input", name);

    return { filterItems, activeItem, onClick };
  },
});
